@if (process) {
    <div
        class="structuredProcess_container"
        [ngClass]="{ intro: !isProcessLoading && !isProcessStarted, 'is-mobile-view': isMobileView }">
        @if (isProcessLoading) {
            <mat-spinner [diameter]="80" [style.justify-self]="'center'"></mat-spinner>
        } @else if (isProcessStarted) {
            <input
                type="file"
                #cvFileInput
                accept="application/pdf"
                style="display: none"
                (change)="uploadCV($event)" />
            <div class="structuredProcess_chatSideContainer" [ngClass]="{ 'is-mobile-view': isMobileView }">
                @if (presentCVAlertToUser && !userJustUploadedCVData && (!isB2C || getCurrentStepNumber() === 4)) {
                    <claro-alert
                        class="structuredProcess_cvAlert"
                        [ngClass]="{ 'is-mobile-view': isMobileView }"
                        [type]="isB2C ? alertTypeEnum.Info : alertTypeEnum.Warning"
                        [hideIcon]="isB2C"
                        [hideHeader]="isB2C"
                        [header]="'structuredProcessView.noCVAlertTitle' | translate"
                        [text]="cvAlertTextKey | gender | translate"
                        [presentDetailsButton]="true"
                        [detailsButtonText]="'structuredProcessView.noCVAlertButtonText' | translate"
                        (seeAlertClicked)="openSelectCVFileSeletionDialog()">
                    </claro-alert>
                }

                <!-- B2B users don't get the end-of-process alert -->
                @if (isB2C && isEndOfProcess && !userDismissedEndOfProcessAlert && !bPresentArtifactView) {
                    <claro-alert
                        class="structuredProcess_cvAlert"
                        [ngClass]="{ 'is-mobile-view': isMobileView }"
                        [type]="alertTypeEnum.Info"
                        [header]="'structuredProcessView.endOfProcessMessageHeader' | translate"
                        [text]="'structuredProcessView.endOfProcessMessage' | gender | translate"
                        [presentDismissButton]="true"
                        (dismissAlertClicked)="userDismissedEndOfProcessAlert = true">
                    </claro-alert>
                }

                @if (showArtifactCreationApprovedAlert) {
                    <claro-alert
                        class="structuredProcess_cvAlert"
                        [ngClass]="{ 'is-mobile-view': isMobileView }"
                        [type]="alertTypeEnum.Info"
                        [header]="'structuredProcessView.workplan.artifactCreationApprovedTitle' | translate"
                        [text]="'structuredProcessView.workplan.artifactCreationApprovedText' | gender | translate"
                        [presentDetailsButton]="true"
                        [detailsButtonText]="'structuredProcessView.workplan.artifactCreationApprovedButtonText' | translate"
                        [presentDismissButton]="true"
                        [dismissButtonText]="'structuredProcessView.workplan.artifactCreationBackButtonText' | translate"
                        (seeAlertClicked)="onArtifactCreationApproved()"
                        (dismissAlertClicked)="onWorkplanBackToPlan()">
                    </claro-alert>
                }

                @if (showB2CGoodbyeMessage && !userDismissedGoodbyeAlert) {
                    <claro-alert
                        class="structuredProcess_cvAlert"
                        [ngClass]="{ 'is-mobile-view': isMobileView }"
                        [type]="alertTypeEnum.Positive"
                        [hideHeader]="true"
                        [text]="'structuredProcessView.goodbyeMessageText' | translate"
                        [presentDismissButton]="true"
                        [dismissButtonText]="'structuredProcessView.goodbyeMessageButtonText' | translate"
                        (dismissAlertClicked)="userDismissedGoodbyeAlert = true">
                    </claro-alert>
                }
                @if ((currentStepStatus == structuredProcessInstanceStatusEnumInstance.COMPLETED || bPresentExternalInfoView) && (bPresentExternalInfoView || bPresentCompentenciesView || bPresentIntroConsentView || bPresentArtifactView) && !(isB2C && getCurrentStepNumber() === 2) && hasNextStep) {
                    <div class="structuredProcess_nextStepContainer" [ngClass]="{'floating-b2c': isB2C, 'floating-external-info': bPresentExternalInfoView}">
                        <button
                            mat-raised-button
                            color="primary"
                            class="structuredProcess_nextStepButton"
                            [ngClass]="{'floating-b2c': isB2C}"
                            (click)="onStartNextStep()">
                            {{ "structuredProcessChat.doneMessageButton" | translate }}
                            <mat-icon class="structuredProcess_nextStepIcon">arrow_forward</mat-icon>
                        </button>
                    </div>
                }

                @if (!bPresentArtifactView && !bPresentCompentenciesView && !bPresentIntroConsentView && !bPresentExternalInfoView) {
                    <app-structured-process-chat
                        #processChat
                        class="structuredProcess_chat"
                        [processId]="currentProcessId"
                        [stageId]="currentStageId"
                        [stepId]="currentStepId"
                        [currentStepStatus]="currentStepStatus"
                        (newMessageReceived)="onNewMessageReceived()"
                        (startNextStepEvent)="onStartNextStep()">
                    </app-structured-process-chat>
                    @if ((currentStepStatus == structuredProcessInstanceStatusEnumInstance.COMPLETED || isB2BHandoffStep || (isB2C && !bPresentIntroConsentView && !bPresentCompentenciesView)) && !(isB2C && (getCurrentStepNumber() === 2 || getCurrentStepNumber() === 3)) && hasNextStep) {
                        <div class="structuredProcess_nextStepContainer">
                            <button
                                mat-raised-button
                                color="primary"
                                class="structuredProcess_nextStepButton"
                                (click)="onStartNextStep()">
                                {{ "structuredProcessChat.doneMessageButton" | translate }}
                                <mat-icon class="structuredProcess_nextStepIcon">arrow_forward</mat-icon>
                            </button>
                        </div>
                    }
                } @else if (bPresentCompentenciesView) {
                    @if (currStep?.stepUrl) {
                        <app-structured-process-compentencies-container
                            class="structuredProcess_compentenciesContainer"
                            #structuredProcessCompentenciesContainer
                            (competenciesCompleted)="onCompetenciesCompleted($event)"
                            (competenciesReset)="onCompetenciesReset()"
                            [stepCompleted]="isCurrentStepCompleted"
                            [externalUrl]="currStep!.stepUrl!"></app-structured-process-compentencies-container>
                    }
                } @else if (bPresentExternalInfoView) {
                    @if (currStep?.stepUrl) {
                        <app-structured-process-external-info
                            class="structuredProcess_compentenciesContainer"
                            [externalUrl]="currStep!.stepUrl!">
                        </app-structured-process-external-info>
                    }
                } @else if (bPresentIntroConsentView) {
                    <app-structured-process-intro-consent
                        class="structuredProcess_introConsentContainer"
                        [currentStepStatus]="currentStepStatus"
                        (consentApproved)="onIntroConsentApproved()"
                        (discoveryCompleted)="onDiscoveryCompleted()">
                    </app-structured-process-intro-consent>
                } @else if (bPresentArtifactView) {
                    <!-- Present the artifact view -->
                    <app-structured-process-artifact-view-workplan
                        #structuredProcessArtifactViewWorkplan
                        class="structuredProcess_artifactView"
                        [processId]="currentProcessId"
                        [isGeneratingArtifact]="isGeneratingArtifact"
                        [isFirstTimeArtifactCreation]="isFirstTimeArtifactCreation">
                    </app-structured-process-artifact-view-workplan>
                }
            </div>
        } @else {
            <app-structured-process-intro-component
                class="structuredProcess_startProcessIntroContainer"
                [doc]="introDoc"
                (action)="startStructuredProcess()"></app-structured-process-intro-component>
        }
    </div>
}
